import { Routes } from '@angular/router';
import { Login } from './auth/login/login';
import { Register } from './auth/register/register';
import { LayoutComponent } from './layout/layout';
import { HomeComponent } from './dashboard/home/home';
import { CourseViewComponent } from './courses/course-view/course-view';
import { CoursePlayerComponent } from './courses/course-player/course-player';
import { CoursesListComponent } from './courses/courses-list/courses-list';
import { ProfileComponent } from './profile/profile';
import { ExamTakeComponent } from './exam/exam-take';
import { ExamNewComponent } from './exam/exam-new';
import { ExamTestComponent } from './exam/exam-test';
import { CalendarComponent } from './calendar/calendar';
import { LiveClassComponent } from './live-class/live-class';
import { AuthGuard } from './guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: Login, data: { animation: 'LoginPage' } },
  { path: 'register', component: Register, data: { animation: 'RegisterPage' } },
  {
    path: 'reset-password',
    loadComponent: () => import('./auth/reset-password/reset-password').then(m => m.ResetPassword),
    data: { animation: 'ResetPasswordPage' }
  },
  {
    path: 'soporte',
    loadComponent: () => import('./public/support/support').then(m => m.SupportPage),
    data: { animation: 'SupportPage' }
  },
  {
    path: 'marketing',
    loadComponent: () => import('./public/marketing/marketing').then(m => m.MarketingPage),
    data: { animation: 'MarketingPage' }
  },
  {
    path: 'dashboard',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    data: { animation: 'DashboardPage' },
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'home', component: HomeComponent },
      { path: 'courses', component: CoursesListComponent, data: { animation: 'CoursesListPage' } },
      { path: 'profile', component: ProfileComponent, data: { animation: 'ProfilePage' } },
      { path: 'calendar', component: CalendarComponent, data: { animation: 'CalendarPage' } }
    ]
  },
  {
    path: 'course/:id',
    component: CourseViewComponent,
    canActivate: [AuthGuard],
    data: { animation: 'CourseViewPage' }
  },
  {
    path: 'course/:id/watch',
    component: CoursePlayerComponent,
    canActivate: [AuthGuard],
    data: { animation: 'CoursePlayerPage' }
  },
  {
    path: 'exam/test/:id',
    component: ExamTestComponent,
    canActivate: [AuthGuard],
    data: { animation: 'ExamTestPage' }
  },
  {
    path: 'exam/old/:id',
    component: ExamTakeComponent,
    canActivate: [AuthGuard],
    data: { animation: 'ExamOldPage' }
  },
  {
    path: 'exam/:id',
    component: ExamNewComponent,
    canActivate: [AuthGuard],
    data: { animation: 'ExamPage' }
  },
  {
    path: 'live-class/:id',
    component: LiveClassComponent,
    canActivate: [AuthGuard],
    data: { animation: 'LiveClassPage' }
  },
  {
    path: 'community',
    canActivate: [AuthGuard],
    data: { animation: 'CommunityPage' },
    loadChildren: () => import('./community/community.routes').then(m => m.COMMUNITY_ROUTES)
  },
  { path: '**', redirectTo: 'login' }
];
